
import { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

import Assign from '../Components/Assign';
import Menubar1 from '../Components/Menubar1';

import reducer from '../Imports/reducerImports';
import { useShared } from '../Utilities/allContext1';
import { DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

import { Dropdown } from 'primereact/dropdown';
import { Menubar } from 'primereact/menubar';
import { Card } from 'primereact/card';

// import 'primereact/resources/themes/saga-blue/theme.css'; // Theme CSS
// import 'primereact/resources/primereact.min.css'; // Core CSS
// import 'primeicons/primeicons.css'; // PrimeIcons CSS (if you are using icons)
        
export default function AssignAll() {

    // const navigate = useNavigate();

    const { setServiceListItem, setServiceOptionListItem, reset4All } = reducer;
    const { getSupervisorList, getManagerList, getAssignList, updateAssignList, getServiceList, getMemberList } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const memberList = useSelector((state) => state.all.memberList);
    const assignList = useSelector((state) => state.all.assignList);
    const serviceList = useSelector((state) => state.all.serviceList);
    const serviceListItem = useSelector((state) => state.all.serviceListItem);
    const managerList = useSelector((state) => state.all.managerList);
    const supervisorList = useSelector((state) => state.all.supervisorList);
    const serviceOptionList = useSelector((state) => state.all.serviceOptionList);
    const serviceOptionListItem = useSelector((state) => state.all.serviceOptionListItem);

    // const [serviceListItem, setServiceListItem] = useState(null);
    //const [serviceOptionList, setServiceOptionList] = useState(null);
    //const [serviceOptionListItem, setServiceOptionListItem] = useState(null);

    // const history = useHistory();

    // const items = [
    //     {
    //         label: '首頁',
    //         icon: 'pi pi-home',
    //         command: () => navigate('/home')
    //     },
    //     {
    //         label: '修改',
    //         icon: 'pi pi-file-edit',
    //         command: () => navigate('/assignall')
    //     },

    //     {
    //         label: '登出',
    //         icon: 'pi pi-sign-out',
    //         command: () => navigate('/signout')
    //     }
    // ];

    const onChangeService = (e) => {
        dispatch(setServiceOptionListItem(e.value));
        let item = serviceList.find(service => service.id === e.value.code);
        dispatch(setServiceListItem(item));
    }

    // useEffect(() => {
    //     reset4All();
    //     if (memberList.length === 0) {
    //         getMemberList();
    //     }    
    //     if (assignList.length === 0) {
    //         getAssignList();
    //     }
    //     if (serviceList.length === 0) {
    //         getServiceList();
    //     }
    //     if (managerList.length === 0) {
    //         getManagerList();
    //     }    
    //     if (supervisorList.length === 0) {
    //         getSupervisorList();
    //     }            
    // }, []);

    // useEffect(() => {
    //     // const list = serviceList.map(serviceListItem => ({
    //     //     name: DEBUG ? `${serviceListItem.name} ID${serviceListItem.id}` : `${serviceListItem.name}`,
    //     //     code: serviceListItem.id
    //     // }));
    //     // setServiceOptionList(list);
    //     // dispatch(setServiceOptionListItem(list[0]));
    //     // setServiceListItem(serviceList[0]);
    // }, [serviceList]);

    return (
        <div>
            <Menubar1 />
            <div className="flex justify-content-center">
                <Dropdown value={serviceOptionListItem} onChange={onChangeService} options={serviceOptionList} optionLabel="name" 
                    checkmark={true} highlightOnSelect={false}  style={{ margin: '20px', padding: '0px' }}/>
            </div>
            {/* {serviceList.map((serviceListItem) => (
                <Assign serviceListItem={serviceListItem}/>
            ))} */}
            {serviceListItem && <Assign serviceListItem={serviceListItem} displayMode={2} modify={true}/>}
        </div>
    )

}